import { AuthenticatedDataRequest } from '@eggplant/data-request'
import {
  FieldLabel,
  Paragraph
} from '@eggplant/pattern-library'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import { SelectRequirementGroup } from '@eggplant/input-controls'
import type {
  CSSProperties,
  ReactNode
} from 'react'
import type { RequirementGroupsResponse } from '@eggplant/types'

type Placement = 'below' | 'beside'

interface Props {
  externalQuery?: ReactNode
  value: string
  onRequirementGroupChange: (value: string) => void
  placement?: Placement
  onGetRequirementGroupChange: (value: RequirementGroupsResponse[]) => void
  isDisabled?: boolean
}

const url = MODELER_SERVICE + '/requirement_groups'

const elementWrapperStyle: CSSProperties = {
  alignItems: 'center',
  display: 'flex',
  gap: '12px'
}

const maxWidthStyle: CSSProperties = {
  maxWidth: '400px'
}

const dropdownStyle: CSSProperties = {
  alignItems: 'center',
  display: 'grid',
  gap: '12px',
  gridAutoFlow: 'column'
}

const SelectAuthRequirementGroup = ({
  externalQuery,
  placement = 'below',
  value,
  onRequirementGroupChange,
  onGetRequirementGroupChange,
  isDisabled
}: Props) => {
  const elementWrapper = (items: RequirementGroupsResponse[]) =>
    <div style={elementWrapperStyle}>
      <div style={maxWidthStyle}>
        <SelectRequirementGroup
          isDisabled={isDisabled}
          onChange={onRequirementGroupChange}
          requirementGroupsData={items}
          value={value}
        />
      </div>
      {externalQuery}
    </div>

  const childRender = (items: RequirementGroupsResponse[]) => placement === 'below'
    ? (
      <FieldLabel label='Requirement group'>
        <SelectRequirementGroup
          isDisabled={isDisabled}
          onChange={onRequirementGroupChange}
          requirementGroupsData={items}
          value={value}
        />
      </FieldLabel>
    )
    : (
      <div style={dropdownStyle}>
        <Paragraph>
          <strong>
            Requirement group
          </strong>
        </Paragraph>
        {elementWrapper(items)}
      </div>
    )

  const handleSuccess = (value: RequirementGroupsResponse[]) => {
    onGetRequirementGroupChange(value)
  }

  const renderContent = () => (
    <AuthenticatedDataRequest
      method='get'
      onSuccess={handleSuccess}
      shortErrorMessage='Failed to load requirement group'
      url={url}
    >
      {(items: RequirementGroupsResponse[]) =>
        childRender(items)}
    </AuthenticatedDataRequest>
  )

  return renderContent()
}

export default SelectAuthRequirementGroup
